import { useWSModal } from "@wingspanhq/fe-component-library";
import { PromptDismiss } from "./index";

export const useModalPromptDismiss = () =>
  useWSModal(PromptDismiss, {
    title: "Are you sure you want to dismiss this notification?",
    size: "S"
  });
